import { motion } from "framer-motion";

const chapters = [
  {
    num: "01",
    title: "Data Ideas & Concepts",
    desc: "Transform raw data into actionable insights with our cutting-edge data management and analysis techniques, designed to drive strategic decision-making.",
  },
  {
    num: "02",
    title: "Business Analytics",
    desc: "Leverage our comprehensive business analytics services to uncover hidden trends and make data-driven decisions that propel your business forward.",
  },
  {
    num: "03",
    title: "Customized Solutions",
    desc: "Benefit from our tailored solutions that address your unique business challenges, ensuring optimal performance and strategic growth.",
  },
];

const About = () => (
  <section id="about" data-testid="about-section" className="py-24 lg:py-16 bg-slate-50/70">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center mb-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="rounded-3xl overflow-hidden border border-slate-200 shadow-2xl shadow-slate-900/10">
            <img
              src="/assets/about-ai.png"
              alt="Pioneering Generative AI"
              className="w-full h-[380px] lg:h-[460px] object-cover"
            />
          </div>
        </motion.div>
        <div>
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="text-xs font-semibold tracking-[0.25em] uppercase text-miti-blue">
              About Millennium Infotech
            </span>
            <h2 className="mt-4 font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900 leading-tight">
              Pioneering Generative AI and Digital Transformation
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-5 text-base md:text-lg text-slate-500 leading-relaxed"
          >
            At Millennium Infotech, we lead the way in innovative AI solutions and digital transformation strategies.
            Our expertise spans across various domains, helping businesses unlock their full potential through
            advanced technology.
          </motion.p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-5">
        {chapters.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`about-chapter-${i + 1}`}
            initial={{ opacity: 0, y: 36 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.65, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            whileHover={{ y: -6 }}
            className="group rounded-2xl border border-slate-200 bg-white p-8 lg:p-10 hover:border-miti-blue/40 transition-colors duration-300"
          >
            <span className="font-heading font-bold text-5xl text-slate-100 group-hover:text-miti-blue/20 transition-colors duration-500">
              {c.num}
            </span>
            <h3 className="mt-5 font-heading font-semibold text-xl text-slate-900">{c.title}</h3>
            <p className="mt-3 text-sm md:text-base text-slate-500 leading-relaxed">{c.desc}</p>
            <div className="mt-6 h-px w-full bg-slate-100">
              <div className="h-px w-0 bg-miti-blue transition-all duration-700 group-hover:w-full" />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default About;
